<template>
    <input :id="inputId" type="text"
           class="text-field"
           v-bind:class="getClass !== null ? inputClass + ' ' + inputId : inputId"
           data-size="s"
           :placeholder="$t(placeHolder)"
           v-model="value"
           @input="onInputChange()"
           @focusout="onInputChange()"
           :data-invalid="dataInvalid ? true : null">
</template>

<script>

    import { EventBus } from "../common/event-bus";

    export default {
        name: "inputBox",
        data() {
            return {
                value: ""
            }
        },
        props: {
            inputId: String,                   // 셀렉트 박스 ID(SPA 페이지에서 로딩된 DOM 중 유일한 값으로 지정할 것)
            inputClass: String,                // Select tag 사용자 정의 Class
            initValue: String,                 // Options key 값이 될  Attribute name
            placeHolder: String,               // PlaceHolder value
            dataInvalid: {
                type: Boolean | String,
                default: false
            },

        },
        mounted(){
            this.value = typeof(!this.initValue) !== 'undefined' ? this.initValue : ""

            EventBus.$on("changeLocale", e => {
                //console.log("getEvent",$(`#${this.inputId}`))

            });
        },
        computed:{
            getClass:function(){
                return typeof(this.inputClass) !== 'undefined' ? this.inputClass : null
            }
        },
        watch: {
            dataInvalid:function(){
                //console.log("catch valid")
                //this.dataInvalid ? $(`.go-vendor.${this.selectId}.ui.dropdown`).attr("data-invalid", true) : $(`.go-vendor.${this.selectId}.ui.dropdown`).removeAttr("data-invalid")
            }
        },
        methods: {

            onInputChange() {
                this.$emit('onInputChange', {'id': this.inputId, 'value': this.value});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/inputBox.vue